/**
 * Per-user share totals for a Gold Diggers team inspect list.
 * Display-only. Does not write ledgers.
 */
export function memberShareTotals(contributions) {
  const byUser = new Map()
  for (const row of contributions || []) {
    const key = String(row?.user || '').trim()
    if (!key) continue
    byUser.set(key, (byUser.get(key) || 0) + (Number(row.shares) || 0))
  }
  return byUser
}

export function totalContributionShares(contributions) {
  return (contributions || []).reduce((sum, row) => sum + (Number(row?.shares) || 0), 0)
}